import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from '../button/button.module';
import { FieldModule } from '../field/field.module';
import { InputColorBoxComponent } from './input-color-box.component';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, FieldModule, ButtonModule],
  declarations: [InputColorBoxComponent],
  exports: [InputColorBoxComponent],
})
export class InputColorBoxModule { }
